export const ImagePanel = ({imageStr}) => {
  return (
  <div className="middlePanel">
    <img className="browseImage" src={`https://artblocks-mainnet.s3.amazonaws.com/28200${imageStr}.png`}/>
  </div>);
}
